export default "assets/jsw-logo.png"